/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SecondaryDiscography
 */
export interface SecondaryDiscography {
    /**
     * 
     * @type {Array<string>}
     * @memberof SecondaryDiscography
     */
    societyIds: Array<string>;
}

/**
 * Check if a given object implements the SecondaryDiscography interface.
 */
export function instanceOfSecondaryDiscography(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "societyIds" in value;

    return isInstance;
}

export function SecondaryDiscographyFromJSON(json: any): SecondaryDiscography {
    return SecondaryDiscographyFromJSONTyped(json, false);
}

export function SecondaryDiscographyFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecondaryDiscography {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'societyIds': json['society_ids'],
    };
}

export function SecondaryDiscographyToJSON(value?: SecondaryDiscography | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'society_ids': value.societyIds,
    };
}

